// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Warp Gates Configuration - Universe Milky Way
 * 
 * Defines warp gates that connect to other universes.
 * Gates are special locations that enable inter-universal travel.
 */

export const warpGates = [
  {
    id: 'gate_milkyway_to_pokemon',
    name: 'ULTRA WORMHOLE BETA',
    type: 'warpgate',
    distance: 3.6,
    destinationUniverse: 'pokemon',
    destinationGate: 'gate-pokemon-milkyway',
    toSystem: 600,
    fuelRequired: 5,
    threat: 'ULTRA BEASTS',
    resources: 'POKÉMON ECOSYSTEMS',
    services: [],
    primaryColor: '#FF0000',
    secondaryColor: '#FFDE00',
    hasRings: true,
    animated: true,
    discovered: true,
    description: 'Stable Ultra Wormhole detected near Earth orbit. Leads to a parallel universe where creatures called "Pokémon" have evolved across multiple planets. Gaming Hub gateway.',
    scanDescription: 'ANALYSIS: Ultra Wormhole to Pokémon Universe detected. Dimensional stability: 98%. Connection point: Kanto Prime system. Gaming Hub access. Gate travel does not consume fuel.',
  },
  {
    id: 'gate_milkyway_to_masseffect',
    name: 'MASS RELAY GATEWAY',
    type: 'warpgate',
    distance: 210,
    destinationUniverse: 'masseffect',
    destinationGate: 'gate-masseffect-milkyway',
    toSystem: 900,
    fuelRequired: 5,
    threat: 'SAFE',
    resources: 'MASS RELAY',
    services: [],
    primaryColor: '#00d4ff',
    secondaryColor: '#0088ff',
    hasRings: true,
    animated: true,
    discovered: false,
    description: 'Ancient mass relay detected. Connection to Citadel space. Element Zero signatures present. Sci-Fi Hub gateway.',
    scanDescription: 'ANALYSIS: Warp gate to Mass Effect universe detected. Prothean mass relay technology. Connection point: The Citadel. Sci-Fi Hub access. Gate travel does not consume fuel.',
  },
  {
    id: 'gate_milkyway_to_dc',
    name: 'SPEED FORCE GATEWAY',
    type: 'warpgate',
    distance: 205,
    destinationUniverse: 'dc',
    destinationGate: 'gate-dc-milkyway',
    toSystem: 1300,
    fuelRequired: 5,
    threat: 'MODERATE',
    resources: 'SPEED FORCE',
    services: [],
    primaryColor: '#0044cc',
    secondaryColor: '#ff0000',
    hasRings: true,
    animated: true,
    discovered: false,
    description: 'Speed Force anomaly detected. Connection to Earth-Prime. Crisis energy signatures. Superhero Hub gateway.',
    scanDescription: 'ANALYSIS: Warp gate to DC universe detected. Speed Force corridor stable. Connection point: Earth-Prime. Superhero Hub access. Gate travel does not consume fuel.',
  },
  {
    id: 'gate_milkyway_to_discworld',
    name: 'DISCWORLD PORTAL',
    type: 'warpgate',
    distance: 120,
    destinationUniverse: 'discworld',
    destinationGate: 'gate_discworld_to_milkyway',
    toSystem: 500,
    fuelRequired: 5,
    threat: 'NARRATIVE CAUSALITY',
    resources: 'MAGIC & TURTLES',
    services: [],
    primaryColor: '#8B4513',
    secondaryColor: '#FFD700',
    hasRings: true,
    animated: true,
    discovered: false,
    description: 'Anomalous flat-space detected. Connection to a disc-shaped world carried by four elephants on a giant turtle. Fantasy Hub gateway.',
    scanDescription: 'ANALYSIS: Warp gate to Discworld detected. Narrative causality field active. Connection point: Ankh-Morpork. Fantasy Hub access. Gate travel does not consume fuel.',
  },
  {
    id: 'gate_milkyway_to_neonmetropolis',
    name: 'NEON METROPOLIS GATEWAY',
    type: 'warpgate',
    distance: 180,
    destinationUniverse: 'neonmetropolis',
    destinationGate: 'gate_neonmetropolis_to_milkyway',
    toSystem: 1100,
    fuelRequired: 5,
    threat: 'CORPORATE',
    resources: 'CYBERPUNK TECH',
    services: [],
    primaryColor: '#00ffff',
    secondaryColor: '#ff00ff',
    hasRings: true,
    animated: true,
    discovered: false,
    description: 'Corporate-controlled dimensional gateway. Connection to a cyberpunk megacity universe. Zaibatsu security protocols active.',
    scanDescription: 'ANALYSIS: Warp gate to Neon Metropolis detected. Corporate encryption detected. Connection point: Central Nexus. Cyberpunk Hub access. Gate travel does not consume fuel.',
  }
];

// Warp gate positions on the map
export const warpGatePositions = {
  'gate_milkyway_to_pokemon': { x: 55, y: 70, z: 5 },
  'gate_milkyway_to_masseffect': { x: 60, y: 55, z: 8 },
  'gate_milkyway_to_dc': { x: 55, y: 40, z: -8 },
  'gate_milkyway_to_discworld': { x: 25, y: 65, z: 10 },
  'gate_milkyway_to_neonmetropolis': { x: 35, y: 45, z: -5 },
};
